import { AxiosInstance, AxiosRequestConfig, AxiosResponse } from 'axios'
import prettyMs from 'pretty-ms'
import { logFactory } from '../../../util'

const log = logFactory('telemetry', 'timing')

enum ResponseTiming {
  GOOD = 500,
  SLOW = 1_250,
  BAD = 2_000,
}

const requestInterceptor = (requestConfig: AxiosRequestConfig) => {
  // @ts-expect-error no meta on request config
  requestConfig.meta = requestConfig.meta ?? {}

  // @ts-expect-error no meta on request config
  requestConfig.meta.requestStart = new Date().getTime()

  return requestConfig
}

const responseInterceptor = (response: AxiosResponse) => {
  try {
    // @ts-expect-error no meta
    const ms = new Date().getTime() - response?.config?.meta?.requestStart
    const formatted = prettyMs(ms)

    let level = ''

    switch (true) {
      case ms >= ResponseTiming.BAD:
        level = '🔴'
        break
      case ms >= ResponseTiming.SLOW:
        level = '🟡'
        break
      case ms >= ResponseTiming.GOOD:
        level = '🔵'
        break
      default:
        level = '🟢'
        break
    }

    log(`${level} ${response?.config?.method?.toUpperCase()} request took ${formatted}`, { url: response?.config?.url })
  } catch (e) {
    // ignore
  }

  return response
}

const applyInterceptors = (instance: AxiosInstance) => {
  instance.interceptors.request.use(requestInterceptor)
  instance.interceptors.response.use(responseInterceptor)

  return instance
}

export { applyInterceptors }
